import PropTypes from 'prop-types';
import React, {Component} from 'react';
import Grid from 'material-ui/Grid';
import Select from './Select';
import { toInt } from '../../lib/helpers';

export class ResinPicker extends Component {
  componentDidMount() {
    const { manufacturerOptions, onChange } = this.props;
    if (manufacturerOptions.length === 1) {
      const manufacturerId = manufacturerOptions[0].value;
      onChange({ manufacturerId });
    }
  }

  onManufacturerChange(event) {
    const { value, onChange } = this.props,
      manufacturerId = toInt(event.target.value),
      id = undefined,
      newValue = Object.assign(value, { manufacturerId, id })
    ;

    onChange(newValue);
  }

  onResinChange(event) {
    const { value, onChange } = this.props,
      id = isNaN(event.target.value)
        ? event.target.value
        : Number(event.target.value),
      newValue = Object.assign(value, { id })
    ;

    onChange(newValue);
  }

  render() {
    const {
      manufacturerOptions,
      resinOptions,
      required,
      validations,
      value
    } = this.props;
    const disableManufacturerSelect =
      manufacturerOptions.length === 1 &&
      value.manufacturerId !== undefined;

    return (
      <Grid container>
        {!disableManufacturerSelect ? (
          <Grid item xs={12} sm={6}>
            <Select
              label="Resin Manufacturer"
              required={required}
              value={value.manufacturerId}
              onChange={this.onManufacturerChange.bind(this)}
              options={manufacturerOptions}
              validations={validations.manufacturerId}
            />
          </Grid>
        ) : null}
        <Grid item xs={12} sm={disableManufacturerSelect ? 12 : 6}>
          <Select
            label="Resin System"
            required={required}
            disabled={resinOptions.length === 0}
            value={value.id}
            onChange={this.onResinChange.bind(this)}
            options={resinOptions}
            validations={validations.id}
          />
        </Grid>
      </Grid>
    );
  }
}

ResinPicker.propTypes = {
  resinOptions:        PropTypes.array.isRequired,
  manufacturerOptions: PropTypes.array.isRequired,
  onChange:            PropTypes.func.isRequired,
  validations:         PropTypes.object,
  value:               PropTypes.object
}

ResinPicker.defaultProps = {
  value: {
    id: undefined,
    manufacturerId: undefined,
  }
}

export default ResinPicker;



// WEBPACK FOOTER //
// ./src/components/common/ResinPicker.js